import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useScrollProviderContext } from '../../../providers/ScrollProvider/ScrollProviderContext';
import { getUserSelectedAccountCode } from '../../../app/appSelectors';
import { PRESET_STAT_PL } from '../../../modules/LiteTrade/liteTradeConstants';
import { sendNotificationMessageAction } from '../../../modules/Notifications/notificationsReducer';
import {
    NOTIFICATION_SUBSCRIBE_TYPES,
    NOTIFICATIONS_MESSAGE_TYPES,
} from '../../../modules/Notifications/notificationsConstants';
import MobileAccountBoxContent from './MobileAccountBoxContent/MobileAccountBoxContent';
import { AB_TESTS_NAMES } from "../../../modules/AbTests/abTestsConstants";
import { useAbTestOption } from "../../../modules/AbTests/abTestsHooks";
import MobileAccountBoxAlwaysRespawnContent from "./MobileAccountBoxContent/MobileAccountBoxAlwaysRespawnContent";
import MobileAccountTopBox from "./MobileAccountBoxContent/MobileAccountTopBox";

function MobileAccountBox() {
    const dispatch = useDispatch();
    const accountCode = useSelector(getUserSelectedAccountCode);
    const { scrollPosition } = useScrollProviderContext();
    const requestIdForPl = useMemo(() => {
        return new Date().getTime().toString();
    }, []);
    const showHomeScreenAlwaysRespawn = useAbTestOption(AB_TESTS_NAMES.HOME_SCREEN_ALWAYS_RESPAWN);
    const isScrolled = scrollPosition > 100;

    useEffect(() => {
        if (accountCode) {
            dispatch(sendNotificationMessageAction({
                type: NOTIFICATIONS_MESSAGE_TYPES.SUBSCRIBE,
                params: {
                    requestId: requestIdForPl,
                    type: NOTIFICATION_SUBSCRIBE_TYPES.ACCOUNT_PL,
                    payload: {
                        type: PRESET_STAT_PL.DAY,
                        accountCode,
                    },
                },
            }));
            return () => {
                dispatch(sendNotificationMessageAction({
                    type: NOTIFICATIONS_MESSAGE_TYPES.UNSUBSCRIBE,
                    params: {
                        requestId: requestIdForPl,
                    },
                }));
            };
        }
    }, [accountCode, dispatch, requestIdForPl]);

    return <>
        {isScrolled && <MobileAccountTopBox/>}

        {
            showHomeScreenAlwaysRespawn
                ? <MobileAccountBoxAlwaysRespawnContent/>
                : <MobileAccountBoxContent/>
        }
    </>
}

export default MobileAccountBox;
